import {doc,onSnapshot} from 'firebase/firestore';
import {readPrefs} from './prefsModel';
// Reading settings must never create a team override or freeze inherited defaults.
export default function subscribeNotificationPrefs(db,uid,scope,onChange,onError=()=>{}) {
 let alive=true,global=null,team=null,legacy=null;
 const emit=()=>{if(alive)onChange(readPrefs(team||global||legacy||{version:2}));};
 const stops=[onSnapshot(doc(db,'users',uid),snapshot=>{legacy=snapshot.data()?.notificationPrefs||null;emit();},onError),onSnapshot(doc(db,'users',uid,'notifPrefs','global'),snapshot=>{global=snapshot.data()||null;emit();},onError)];
 if(scope!=='global')stops.push(onSnapshot(doc(db,'users',uid,'notifPrefs',scope),snapshot=>{team=snapshot.data()||null;emit();},onError));
 return()=>{alive=false;stops.forEach(stop=>stop());};
}
